module.exports = __webpack_public_path__ + "img/fylke-15.6658b2ba.svg";